/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isEqual } from '../../../../utils/lodash-utils'

import Filter from '../Filter'

import MetricsSelection from './MetricsSelection'


class Selection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      selectAll: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (this.state.searchTerm !== nextState.searchTerm || !isEqual(this.props.types, nextProps.types))
  }

  handleFilterChange(searchTerm) {
    this.setState({
      searchTerm,
    });
  }

  getFilteredMetricTypes() {
    const { searchTerm } = this.state;
    const {
      types,
    } = this.props;
    if (searchTerm.length) {
      return types.filter((metricType) => {
        return metricType.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
      });
    } else {
      return types
    }
  }

  onSelectAll() {
    const { selectAll } = this.state
    const {
      onSelectAll,
      setColumns,
      contextValue,
    } = this.props
    this.setState({
      selectAll: !selectAll,
    }, () => {
      onSelectAll(contextValue, this.state.selectAll)
      if (this.state.selectAll === true) {
        setColumns(2)
      } else {
        setColumns(1)
      }
    })
  }

  render() {
    const {
      searchTerm,
      selectAll,
    } = this.state;

    return (
      <div className="selection">
        <div className="filter-box">
          <Filter onChange={this.handleFilterChange.bind(this)} value={searchTerm} />
        </div>
        <MetricsSelection
          metricTypes={this.getFilteredMetricTypes()}
          initiallyOpen={true} />
      </div>
    );
  }
}

Selection.propTypes = {
  types: PropTypes.array,
  onCheck: PropTypes.func,
}

export default Selection;
